document.addEventListener("DOMContentLoaded", function() {
  var videoWrapper = document.querySelector(".bm-lp-doctors-review-videos");
  var videos = videoWrapper.querySelectorAll(".videos__video");
  var firstVideo = videoWrapper.querySelector(".videos__video.video--first");

  // Event listeners
  videos.forEach(function(vid) {
    var btn = vid.querySelector("button.video--play");
    var video = vid.querySelector("video:not(.autoplay--first)");

    btn.addEventListener("click", function(e) {
      e.preventDefault();

      videos.forEach(function(v) {
        // remove the first autoplay video
        if (v.querySelector("video.autoplay--first")) {
          v.querySelector("video.autoplay--first").remove();
          v.classList.remove("video--first");
        }
        
        // pause all other videos
        v.querySelector("video").pause();
      })

      // play current video
      this.parentElement.querySelector("video").play();
    })

    video.addEventListener("click", function(e) {
      e.preventDefault();
      this.pause();
    })
  })

  // Update video state classes
  videos.forEach(function(vid) {
    var video = vid.querySelector("video:not(.autoplay--first)");
    if (video) {
      video.addEventListener("ended", function() {
        vid.classList.remove("active--playing", "active--paused");
      });

      video.addEventListener("play", function() {
        vid.classList.add("active--playing");
        vid.classList.remove("active--paused");
      });

      video.addEventListener("pause", function() {
        vid.classList.remove("active--playing");
        vid.classList.add("active--paused");
      });
    }
  });

  // Check first video playback using Intersection Observer
  if (firstVideo) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var video = firstVideo.querySelector("video.autoplay--first");
          if (video && video.paused) {
            video.play();
          }
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(videoWrapper);
  }
})